const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins

class SystemCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        breakpoints: {
          '(max-width: 767px)': {
            disabled: true,
          },
          '(min-width: 768px)': {
            slides: {
              perView: 2.2,
              spacing: 12,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 2.7,
              spacing: 12,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('system-carousel')) {
  customElements.define('system-carousel', SystemCarousel)
}
